/*(function () {
  const GIFT_VARIANT_ID = '44336497360950';
  const GIFT_ROW_CLASS = 'merged-gift-row';

  let debounceTimer = null;

  function mergeGiftItems() {
    const tbody = document.querySelector('.order-summary__body');
    if (!tbody) return;

    const giftRows = Array.from(
      tbody.querySelectorAll(`tr[p-variant-id="${GIFT_VARIANT_ID}"]`)
    );

    // eski merged row'u HER ZAMAN temizle
    const oldMerged = tbody.querySelector(`.${GIFT_ROW_CLASS}`);
    if (oldMerged) oldMerged.remove();

    if (giftRows.length === 0) return;

    // gerçek satırları gizle
    giftRows.forEach(row => {
      row.style.display = 'none';
    });

    const firstRow = giftRows[0];
    const title =
      firstRow.querySelector('a.h6')?.innerText || 'Hediye Ürün';
    const image =
      firstRow.querySelector('img')?.getAttribute('src') || '';

    const mergedRow = document.createElement('tr');
    mergedRow.className = GIFT_ROW_CLASS;

    mergedRow.innerHTML = `
      <td>
        <div style="display:flex;align-items:center;gap:12px">
          ${image ? `<img src="${image}" style="width:60px;height:auto" />` : ''}
          <div>
            <div style="font-weight:600">${title} x${giftRows.length}</div>
            <div style="font-size:12px;opacity:.7">🎁 Ücretsiz Hediye</div>
          </div>
        </div>
      </td>
      <td class="text-center">–</td>
      <td class="text-end">0.00TL</td>
    `;

    tbody.prepend(mergedRow);
  }

  function scheduleMerge() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      mergeGiftItems();
    }, 180); // 🔥 kritik değer
  }

  document.addEventListener('DOMContentLoaded', scheduleMerge);

  const observer = new MutationObserver(scheduleMerge);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();*/


document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('cart:change', function () {
    document.dispatchEvent(new Event('cart:updated'));
  });

  document.addEventListener('cart:refresh', function () {
    document.dispatchEvent(new Event('cart:updated'));
  });

  // Prestige Ajax Add sonrası tetikleme
  document.body.addEventListener('click', function(e){
    if (e.target.closest('button[name="add"]')) {
      setTimeout(function(){
        document.dispatchEvent(new Event('cart:updated'));
      }, 800);
    }
  });

});




document.addEventListener("DOMContentLoaded", function () {
  const redirectPaths = [
    "/collections/vendors",
    "/collections/all"
  ];

  if (redirectPaths.includes(window.location.pathname)) {
    window.location.href = "/";
  }
});


